@for (name of visibleNames(); track $index) {
    <span class="avatar" [class.last]="showFadeOutEffect() && $last">
        <app-cerrix-avatar class="clickable" [name]="name" (click)="addRequested.emit()" />
    </span>
}
@if (hiddenNames().length && readonly()) {
    <span class="avatar">
        <span class="more" [title]="hiddenTitle()">+{{ hiddenNames().length }}</span>
    </span>
}
@if (showAddButton()) {
    <button
        class="add"
        type="button"
        data-uiid="avatar-group-add-button"
        [attr.aria-label]="addLabel() || ('addLabel' | t)"
        [title]="addLabel() || ('addLabel' | t)"
        (click)="addRequested.emit()"
    >
        <app-cerrix-avatar icon="add-user" />
    </button>
}
@if (!names().length && !showAddButton()) {
    <span class="empty">{{ emptyText() || ("emptyText" | t) }}</span>
}
